<template>
  <modalWindow v-if="modify" @close="clearMessage();modify=false">
    <div class="titlebar">Gebruiker aanpassen</div>
    <div v-if="msg.msg" :class="['form-' + msg.type]">{{ msg.msg }}</div>
    <form @submit.prevent class="inset">
      <input type=text ref="modname" placeholder="Naam">
      <input type=text ref="modusername" placeholder="Gebruikersnaam">
      <input type=email ref="modemail" placeholder="E-mail">
      <input type=hidden ref="moduser" placeholder="User">
      <select ref="modrole" placeholder="Role">
        <option value=-1>Lead</option>
        <option value=0>Gebruiker</option>
        <option value=2>Adviseur PLUS</option>
        <option value=8>Beheerder</option>
        <option value=9>Admin</option>
        <option value=10 v-if="$parent.role > 9">Superadmin</option>
      </select>
      <input type=submit @click="modifyUser" value="User aanpassen">
    </form>
  </modalWindow>
</template>

<script>
import { find } from 'lodash-es';

export default {
  name: 'ModifyUser',
  data() {
    return {
      modify: false,
      msg: { msg: null, type: 'notice' },
    };
  },
  methods: {
    clearMessage() {
      this.msg = { msg: null, type: 'notice' };
    },
    userModify(id) {
      this.modify = true;
      const user = find(this.$parent.users, { id });
      this.$nextTick(() => {
        this.$refs.moduser.value = user.id;
        this.$refs.modname.value = user.name;
        this.$refs.modusername.value = user.username;
        this.$refs.modemail.value = user.email;
        this.$refs.modrole.value = user.role;
      });
    },
    modifyUser() {
      this.sdk.modifyUser(
        this.$refs.moduser.value,
        this.$refs.modname.value,
        this.$refs.modusername.value,
        this.$refs.modemail.value,
        this.$refs.modrole.value,
        (response) => {
          if (response.status === 200) {
            this.$parent.getUsers();
            this.modify = false;
          } else {
            this.msg = { msg: response.data.message, type: 'error' };
          }
        },
      );
    },
  },
};
</script>
